export default [{type:"image\u002Fwebp",srcset:".\u002Fassets\u002Flove.340f3b63.webp 325w",loading:"lazy",src:".\u002Fassets\u002Flove.340f3b63.webp"}]